<template>
    <form class="">
        <div class="">
            <div v-for="(field, index) in tableFieldsOptions" :key="index"  class="custom-control custom-checkbox">
                <input v-model="field.visible" type="checkbox" :id="`table-field-id-${index}`" class="custom-control-input">
                <label class="custom-control-label" :for="`table-field-id-${index}`">{{ field.label }}</label>
            </div>
        </div>
        <!--button type="submit" class="btn btn-primary btn-sm"><i class="fas fa-save"></i> Guardar</button-->
    </form>
</template>

<script>
export default {
    props: {
        fields: {
            required: true,
            type: Array
        }
    },

    data() {
        return {
            tableFieldsOptions: this.fields
        }
    }
}
</script>
